import React from "react";
import SideNav from "./navigation/SideNav";
import "./AppFrame.css";
import SideNavMobile from "./navigation/SideNavMobile";

const style = {
  container_mobile: {
    display: "flex",
    flexFlow: "Column", //Change
  },
  container_desktop: {
    display: "flex",
    flexFlow: "row",
  },
  content: {
    margin: 0, //in mobile, change to 0
    width: "100%",
    height: "100vh",
    overflowY: "auto",
  },
};

export default ({
  children,
  header,
  optionsType = "",
  whiteLabelSettings = null,
}) => (
  <div>
    <div
      className="side-nav-mobile"
      style={{
        backgroundColor:
          whiteLabelSettings && whiteLabelSettings.isWhiteLabel
            ? whiteLabelSettings.primaryColor
            : "",
      }}
    >
      <SideNavMobile title={header} />
    </div>
    <div className="achealth-page">
      <div className="side-nav">
        <SideNav optionsType={optionsType} />
      </div>
      <div
        className="achealth-page__main"
        style={{
          backgroundColor:
            whiteLabelSettings && whiteLabelSettings.isWhiteLabel
              ? whiteLabelSettings.primaryColor
              : "",
        }}
      >
        <div
          className="achealth-page__header"
          style={{
            backgroundColor:
              whiteLabelSettings && whiteLabelSettings.isWhiteLabel
                ? whiteLabelSettings.primaryColor
                : "",
          }}
        >
          <h1>{header}</h1>
        </div>
        <div className="achealth-page__content">{children}</div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/layout/Appframe/AppFrame.js